import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

import SubSection from 'components/common/section/sub-section/SubSection';
import EmptyStateMessageBody from 'components/common/section/sub-section/EmptyStateMessageBody';
import ElevatedContainer from 'components/common/section/ElevatedContainer';
import { sendUIEvent } from 'services/analytics';
import { SCREEN_NAME } from 'constants/index';
import useIsPersonalView from 'utils/useIsPersonalView';
import { usePathParam } from 'react-resource-router';

const Events = () => {
  const [unifiedProfileUsername] = usePathParam('pathProfileId');
  const isPersonalView = useIsPersonalView(unifiedProfileUsername as string);
  const sendEventsAnalytics = () => {
    sendUIEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'eventsLinkProfile',
      isPersonalView: true,
      source: SCREEN_NAME.PROFILE,
    });
  };

  if (!isPersonalView) {
    return null;
  }

  return (
    <ElevatedContainer>
      <div data-testid="events-container" css={eventsContainerStyles}>
        <SubSection title="Community Events">
          <EmptyStateMessageBody
            message="Join an upcoming community event to learn, connect, and swap tips with other Atlassian users."
            linkTo={`https://ace.atlassian.com/`}
            linkType="external"
            sendAnalyticsEvent={sendEventsAnalytics}
            linkText="Explore events"
          />
        </SubSection>
      </div>
    </ElevatedContainer>
  );
};

export default Events;

const eventsContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.600'),
  '@media (max-width: 767px)': {
    gap: token('space.400'),
  },
});
